import { useEffect, useState } from "react";
import { getBlogDetail, getBlogs } from "../services/api/api";
import { useParams } from "react-router-dom";
import Slider from "react-slick";

const AiBeyondChatbots = () => {
  const settings = {
    slidesToShow: 3.5,
    slidesToScroll: 1,
    draggable: true,
    arrows: false,
    className: "blog_list",
    focusOnSelect: true,
    adaptiveHeight: false,
    prevArrow: (
      <div className="slickbtn slick-prev">
        <svg
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="25.5"
            cy="25.5"
            r="25.5"
            transform="rotate(180 25.5 25.5)"
            fill="url(#paint0_linear_17_4)"
          ></circle>
          <path
            d="M21.414 26L31 26L31 24L21.414 24L25.707 19.707L24.293 18.293L17.586 25L24.293 31.707L25.707 30.293L21.414 26Z"
            fill="white"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear_17_4"
              x1="-0.721698"
              y1="21.675"
              x2="51.0345"
              y2="22.22"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#09C2C1"></stop>
              <stop offset="1" stop-color="#1D85D8"></stop>
            </linearGradient>
          </defs>
        </svg>
      </div>
    ),
    nextArrow: (
      <div className="slickbtn slick-next">
        <svg
          width="51"
          height="51"
          viewBox="0 0 51 51"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="25.5"
            cy="25.5"
            r="25.5"
            fill="url(#paint0_linear_17_8)"
          ></circle>
          <path
            d="M29.586 25L20 25L20 27L29.586 27L25.293 31.293L26.707 32.707L33.414 26L26.707 19.293L25.293 20.707L29.586 25Z"
            fill="white"
          ></path>
          <defs>
            <linearGradient
              id="paint0_linear_17_8"
              x1="-0.721698"
              y1="21.675"
              x2="51.0345"
              y2="22.22"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#09C2C1"></stop>
              <stop offset="1" stop-color="#1D85D8"></stop>
            </linearGradient>
          </defs>
        </svg>
      </div>
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: false,
        },
      },
    ],
  };

  const [blog, setBlog] = useState([]);
  let { blogId } = useParams();
  useEffect(() => {
    getBlogDetail(blogId).then((res) => {
      setBlog(res.data.result);
    });
  }, []);
  console.log(blog);
  return (
    <>
      <div
        className="blog_banner blog-dtl"
        style={{ backgroundImage: "url(./assets/images/new/blog-dtl.png)" }}
      >
        <div className="wrapper">
          <div className="blog-dtl-block">
            <a href="/blogs">
              <img src="/assets/images/new/arrow-blog.svg" alt="arrow" />
            </a>
            {/* this is banner is dynamic */}
            <img src="/assets/images/blogs/blog22.jpg" alt="blog" />
          </div>
        </div>
      </div>
      <div className="block-dtl">
        <div className="wrapper">
          <div className="social">
            <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/Facebook.svg"
                alt="facebook"
              />
            </a>
            <a href="https://www.linkedin.com/shareArticle?mini=true&url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/Linkedin.svg"
                alt="facebook"
              />
            </a>
            <a href="https://pinterest.com/pin/create/button/?url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img src="/assets/images/site/social/Social.svg" alt="facebook" />
            </a>
            <a href="https://x.com/intent/tweet?url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/twitter.png"
                alt="facebook"
              />
            </a>
            <a href="https://www.instagram.com/?url=https%3A%2F%2Fcodeflixweb.com%2Fbest-UI-UX-design">
              <img
                src="/assets/images/site/social/Instagram.svg"
                alt="facebook"
              />
            </a>
          </div>
          <div className="title">
            <div className="title-head">
              <a
                data-aos="zoom-out-up"
                href="javascript:void(0)"
                className="button-container-1 aos-init aos-animate"
              >
                <span className="mas">
             AI Beyond Chatbots
                  {/* this is tag name (dynamic) */}
                </span>
                <span className="mask_btn">
             AI Beyond Chatbots
                  {/* this is tag name (dynamic) */}
                </span>
              </a>

              <span>October 7, 2025</span>
            </div>
            {/* all this content is dynamic  */}
            <div
            // dangerouslySetInnerHTML={{ __html: blog.page_content }}
            >
              <h2>
              AI Beyond Chatbots: How Intelligent Agents Can Negotiate, Resolve Disputes & Run Workflows
              </h2>
              <br></br>
             
  <p>When we think of AI in business, most of us imagine chatbots answering FAQs or AI copilots drafting emails. But in 2025, AI has gone far beyond that. We’re entering the age of AI agents that can negotiate contracts, settle disputes, and even manage enterprise workflows end-to-end. This isn’t science fiction anymore it’s already happening.</p>

  <h3>From Chatbots to Deal-Makers</h3>
  <p>Traditional chatbots are reactive: you ask a question, they give an answer. But the new generation of AI agents is proactive and autonomous. They don’t just respond they reason, plan, and act.</p>
  <p><strong>Example:</strong> Instead of just showing you a pricing FAQ, an AI negotiation agent could analyze customer budgets, offer discounts within company rules, and close the deal on its own.</p>

  <h3>AI for Dispute Resolution</h3>
  <p>Conflict is common in business missed payments, delivery delays, service complaints. Instead of relying on long back-and-forth emails, AI agents can:</p>
  <ul>
    <li>Analyze contracts and identify obligations</li>
    <li>Suggest fair settlements based on historical cases</li>
    <li>Mediate between parties with neutral reasoning</li>
  </ul>
  <p><strong>Example:</strong> In e-commerce platforms, AI mediators are already resolving seller-buyer disputes in seconds that used to take days.</p>

  <h3>AI Handling Enterprise Workflows</h3>
  <p>AI agents are also stepping into enterprise operations, where they can:</p>
  <ul>
    <li>Approve expense claims by checking policies automatically</li>
    <li>Assign support tickets to the right teams</li>
    <li>Monitor projects and send alerts when deadlines slip</li>
    <li>Generate compliance reports without human input</li>
  </ul>
  <p><strong>Example:</strong> In IT service companies, AI agents can triage 80% of support tickets before a human ever gets involved.</p>

  <h3>Technologies Making This Possible</h3>
  <ul>
    <li>Large Language Models (LLMs) – OpenAI GPTs, Anthropic Claude, Google Gemini</li>
    <li>Autonomous AI Frameworks – Auto-GPT, BabyAGI, LangChain</li>
    <li>Agent Management Tools – AgentOps, CrewAI</li>
    <li>Decision Systems – AI integrated with CRMs, ERPs, and workflow automation platforms</li>
  </ul>

  <h3>Business Benefits</h3>
  <ul>
    <li>Faster decision-making</li>
    <li>Lower legal and operational costs</li>
    <li>24/7 availability</li>
    <li>Consistent and unbiased outcomes</li>
    <li>Employees freed from repetitive admin tasks</li>
  </ul>

  <h3>Challenges Ahead</h3>
  <ul>
    <li>Trust and Transparency – Can businesses trust AI’s negotiation decisions?</li>
    <li>Regulation – Who is accountable if an AI-made settlement goes wrong?</li>
    <li>Ethics – Ensuring fairness in automated dispute resolutions</li>
  </ul>

  <h3>The Future: AI as Digital Colleagues</h3>
  <p>Soon, businesses may have AI agents as part of their teams:</p>
  <ul>
    <li>One AI agent negotiating vendor contracts</li>
    <li>Another resolving disputes with customers</li>
    <li>A third managing finance workflows</li>
  </ul>
  <p>Together, they will act like digital colleagues tireless, efficient, and data-driven.</p>

  <h3>Final Thoughts</h3>
  <p>AI is no longer just a chatbot it’s becoming a negotiator, mediator, and workflow manager. For IT companies, this opens up exciting possibilities to cut costs, improve customer satisfaction, and scale operations like never before.</p>




            </div>
          </div>
        </div>
      </div>
      <div className="topics-sec">
        <div className="wrapper">
          <div className="topics-head">
            <h3>related topics</h3>
            <a
              data-aos="zoom-out-up"
              href="/blogs"
              className="button-container-1 aos-init aos-animate"
            >
              <span className="mas">View More</span>
              <span className="mask_btn">View More</span>
            </a>
          </div>
          <div className="topics-block">
            <Slider {...settings}>
              {/* href id is dynamic like blog/item.id */}
              <a href={`/best-web-development-company`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="./assets/images/blogs/blog1.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span> Web Development</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        Best Web Development Company: Transforming Your Digital
                        Presence Globally
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <a href={`/custom-mobile-app-development-services`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="./assets/images/blogs/blog16.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span>App Development</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        Elevate Your Business with Custom Mobile App Development
                        Services
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <a href={`/leading-php-company`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="./assets/images/blogs/blog15.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span> Web Development</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        Leading PHP Development Company in India: Unlocking Your
                        Digital Potential
                      </div>
                    </div>
                  </div>
                </div>
              </a>
              <a href={`/best-UI-UX-design`}>
                <div className="topics-slider">
                  <div className="element">
                    {/* this image is blog banner (logo.url) */}
                    <img src="/assets/images/blogs/blog9.jpg" alt="blogs" />
                    <div className="slide-dtls">
                      {/* {item.tags.map((tag, index) => {
                                  return <span>{tag.name}</span>;
                                })} */}
                      <span>ui & ux</span>
                      {/* call page content h2 tag text */}
                      <div
                      // dangerouslySetInnerHTML={{
                      //   __html: page_content[0],
                      // }}
                      >
                        We Provide the Best UI/UX Design Solutions for
                        Exceptional User Experiences{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiBeyondChatbots;
